import { Component, Vue } from 'vue-property-decorator';
import Hamburger from '@/components/SideNavigation/Hamburger/Hamburger';
import { getStyleSkinName } from '@/tools/helpers.ts';

@Component<SideNavigation>({
  components: {
    Hamburger,
  },
})
export default class SideNavigation extends Vue {
  protected getStyle: any = getStyleSkinName();
  protected sideNavigationActive: boolean = false;

  public mounted() {
    //
  }

  protected toggleSideNavigation() {
    this.sideNavigationActive = !this.sideNavigationActive;
  }
}
